module.exports = __webpack_public_path__ + "img/info-toast-icon.3840fe01.svg";